import { render, staticRenderFns } from "./BillExchangeCheckoutForm.vue?vue&type=template&id=00fc4636&scoped=true"
import script from "./BillExchangeCheckoutForm.vue?vue&type=script&lang=js"
export * from "./BillExchangeCheckoutForm.vue?vue&type=script&lang=js"
import style0 from "./BillExchangeCheckoutForm.vue?vue&type=style&index=0&id=00fc4636&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fc4636",
  null
  
)

export default component.exports